import FeatureFlagProps from '../../FeatureFlagProps';
import HideFeatureComponent from './HideFeature';
import HideFeatureWithContext from './HideFeatureWithContext';

const HideFeature = (props: FeatureFlagProps) =>
  props.allFeatureFlags ?
    <HideFeatureComponent {...props} /> :
    <HideFeatureWithContext {...props} />

export default HideFeature;
